const variables = {
    'primary': '#5D6DFD',
    'danger': '#E03F3F',

    'bg': '#000000',
    'bg-sub': '#1A2D474D',
    'color': '#FFFFFF',
    'color-secondary': '#00FEDF',
    'color-blue': '#03a9f4',
    'color-fourth': '#41CD7D',
    'color-4': 'rgba(255,255,255,.6)',
    'placeholder-color': '#C1C1C1',

    'input-bg': 'rgba(0,0,0,.4)',
    'input-color': '#9BA2B2',

    'font-size': '15px',
    'font-size-1': '4rem',
    'font-size-2': '3rem',
    'font-size-3': '1.75rem',
    'font-size-4': '1.5rem',
    'font-size-5': '1rem',
    'font-size-6': '0.8rem',
    'section-w': '1200px',
    'body-font': 'Titillium Web',
    'heading-font': 'Ocat'
}

export const smVariables = {
    'font-size': '12px',
    'font-size-1': '1.9rem',
    'font-size-2': '1.58rem',
    'font-size-3': '0.75rem',
    'font-size-4': '1rem',
}

export default variables;
